import { alertWithMessage } from "components/modal/message_modal";
import { alertWithSuccessMessage } from "components/modal/success_modal";
import { MaxButton, StatusMaxButton } from "components/view/button";
import Spinner from "components/view/loader";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import cliam_commission_ranking from "lib/worker/api/cliam_commission_ranking";
import get_transaction_commission_ranking_by_member_id, {
  GetTransactionCommissionRankingByMemberIDResponse,
} from "lib/worker/api/get_transaction_commission_ranking_by_member_id";
import { GetServerSideProps } from "next";
import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

interface Props {
  state: AppReducerStateProps;
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function AgentReward(props: Props) {
  const [comissionList, setcommissionList] = useState<
    GetTransactionCommissionRankingByMemberIDResponse[]
  >([]);
  const [loading, setloading] = useState<boolean>(false);

  useEffect(() => {
    if (props.isLogin) {
      reload();
    }
  }, []);

  const reload = () => {
    setloading(true);
    get_transaction_commission_ranking_by_member_id()
      .then(setcommissionList)
      .finally(() => {
        setloading(false);
      });
  };

  const cliamComission = (hashkey: string) => {
    cliam_commission_ranking({ hashkey: hashkey })
      .then((resp) => {
        alertWithSuccessMessage(resp.message ?? "");
      })
      .catch((error: any) => {
        alertWithMessage(error.response.data.message);
      })
      .finally(() => {
        reload();
      });
  };

  return (
    <>
      <h1 style={{ fontSize: 20 }}>
        <span>รายได้ประจำเดือนของตัวแทนทุกวันที่ 1 ของเดือน</span>
      </h1>
      {loading ? (
        <Spinner></Spinner>
      ) : (
        <>
          {comissionList.length == 0 ? (
            <div className="container card card-ufa-category color-font-card shadow">
              <div className="margin-left-10">
                <div className="row">
                  <div className="col-6">
                    <div className="margin-top-10">ยังไม่มีรางวัล</div>
                  </div>
                  <div className="col-6">
                    <div className="text-right margin-right-10 margin-top-10 margin-bottom-10">
                      -
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            comissionList.map((v, i) => {
              return (
                <div
                  key={i}
                  className="container card-ufa-category card border-ufa-grey color-font-card shadow"
                >
                  <div className="margin-left-10">
                    <div className="row">
                      <div className="col-9">
                        <div className="margin-top-10">
                          ได้รับรางวัล{" "}
                          <span>{v.Amount?.format(2, 0)} เครดิต</span>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="text-right">
                          <MaxButton
                            title={v.Uncalculated ? "รับแล้ว" : "รับ"}
                            style={{
                              width: 100,
                              float: "right",
                              marginRight: 10,
                              marginTop: 20,
                            }}
                            status={StatusMaxButton.submit}
                            lock={v.Uncalculated}
                            onClick={() => {
                              cliamComission(v.HashKey ?? "");
                            }}
                          ></MaxButton>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="margin-left-10">
                    <div className="row">
                      <div style={{ flex: 1 }}></div>
                      <div
                        className="margin-bottom-10"
                        style={{ marginTop: -10 }}
                      >
                        {v.DisplayCreatedAt}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </>
      )}
    </>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(AgentReward);
